import { useTenant, ConfigSetting } from '@parcel2go/npm-p2g-app';
import { UnitSystem } from '~/apps/smartsend/lib/helpers/DimensionUnits';

const parseUnit = (value?: string): UnitSystem | undefined => {
  const v = value?.toLowerCase();
  return v === 'metric' || v === 'imperial' ? v : undefined;
};

// US is the only imperial market today; everything else defaults to metric.
const isImperialCountry = (hostCountry?: string): boolean => {
  const c = hostCountry?.toUpperCase();
  return c === 'USA' || c === 'US';
};

const DISPLAY_UNITSYSTEM_KEY = 'UI-SERVERLESS.PUBLIC.DISPLAY.UNITSYSTEM';

/**
 * Resolves the active weight/dimension unit system: tenant default > country fallback (US ->
 * imperial, else metric). There is no user-facing override yet, so `UNITSYSTEMENFORCED` makes no
 * difference here - the tenant default already wins whenever it's set.
 */
export function useMeasurementSystem(): { unit: UnitSystem } {
  const { settings } = useTenant();

  const countryUnit: UnitSystem = isImperialCountry(settings[ConfigSetting.HOST_COUNTRY]) ? 'imperial' : 'metric';
  const unit: UnitSystem = parseUnit(settings[DISPLAY_UNITSYSTEM_KEY]) ?? countryUnit;

  return { unit };
}
